import * as pdfjs from 'pdfjs-dist';

// Use the worker file from the public folder
// This ensures it works in production builds and supports offline PWA functionality
pdfjs.GlobalWorkerOptions.workerSrc = '/pdfjs/pdf.worker.mjs';

export default pdfjs;
